// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19i-R","question":"styles_question__1pGBX","description":"styles_description__2VgSp"};